import React, { Component } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '../Link.js';
import ReactGA from 'react-ga';
import splashlogo from './img/splash_logo.png';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.setVisibility = this.setVisibility.bind(this);
    this.visibility = ['hidden', 'shown'];
    this.addDecoration = this.addDecoration.bind(this);
  }

  setVisibility(e) {
    let target = e.target.value.toLowerCase();
    if (this.state[target] === this.visibility[1]) {
      this.setState({
        [target]: this.visibility[0],
      });
    } else {
      this.setState({
        [target]: this.visibility[1],
      });
    }
  }
  addDecoration() {
    return (
      <p style={{ textAlign: 'center', padding: 0, margin: '0 0 20px 0', fontSize: '2em', color: '#324C7E' }}>.</p>
    );
  }

  componentDidMount() {
    ReactGA.initialize('UA-18240989-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    // const _fontSize = '1.13em';
    return (
      <div className='App'>
        <div className='splash'>
          <img src={splashlogo} alt={`Dan Kinsley Web Developer Logo`} />
          <div className='experience'>
            {/* {this.addDecoration()} */}
            <h1>
              Software Engineer III
              <br />
              Seasoned Full-Stack Developer
            </h1>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li>
                <Link name='github' url='https://github.com/mckinselberg' title='GitHub profile and repositories' />
              </li>
              <li>
                <Link
                  name='linkedin'
                  url='https://www.linkedin.com/in/dan-kinsley-devloper/'
                  title='LinkedIn professional profile'
                />
              </li>
              <li>
                <span
                  style={{
                    display: 'inline-block',
                    width: '4ch',
                    height: '1px',
                    background: '#d0d4db',
                    margin: '6px auto',
                  }}
                />
              </li>
              <li>
                <Link
                  name='synth'
                  url='https://synth-irbu.onrender.com/'
                  title='Web synth experiment with audio APIs'
                />
              </li>
              <li>
                <Link name='pinky' url='https://pinky-ypr7.onrender.com/' title='Sidescrolling game built on phaser' />
              </li>

              <li>
                <RouterLink className='code' to='/music' title="Dan Kinsley's Audio Player">
                  music
                </RouterLink>
              </li>
              <li>
                <Link
                  name='rtc-chat'
                  url='https://rtc-chat.onrender.com/'
                  title='WebRTC chat prototype. Connect two users from different browsers and they can chat over websockets.'
                />
              </li>
              {/* <li>
                <Link
                  name='cube'
                  url='https://cube-bk45.onrender.com/'
                  title='3D rubiks cube / WebGL demo (in progress)'
                />
              </li> */}
              {/* <li>
                <Link
                  name='sveres'
                  url='https://sveres.onrender.com/'
                  title='Sandbox game prototype with interactive visuals and audio'
                />
              </li> */}
              {/* <li>
                <Link
                  name='oscilloscope'
                  url='https://audio-art.onrender.com/'
                  title='Oscilloscope emulator (in progress)'
                />
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
